<button mat-button class="more-filters-button" [matMenuTriggerFor]="moreFiltersMenu" [disabled]="getAvailableFilters().length === 0">
  <span class="button-text">More filters</span>
  <mat-icon class="button-icon">keyboard_arrow_down</mat-icon>
</button>

<mat-menu #moreFiltersMenu="matMenu" class="more-filters-menu">
  <div class="search-section">
    <input type="text" class="search-input" placeholder="Search filters..." [value]="searchTerm" (input)="onSearchChange($any($event.target).value)" (click)="$event.stopPropagation()" />
    <mat-icon class="search-icon">search</mat-icon>
  </div>

  <mat-divider></mat-divider>

  <div class="filters-list">
    @for (filter of filteredOptions; track trackByFilterId($index, filter)) {
    <div class="filter-option" (click)="onFilterSelect(filter)">
      <div class="filter-content">
        <div class="filter-icon">
          <mat-icon>{{ getFilterIcon(filter.type) }}</mat-icon>
        </div>

        <div class="filter-info">
          <span class="filter-label">{{ filter.label }}</span>
          <span class="filter-description">{{ getFilterDescription(filter) }}</span>
        </div>
      </div>

      <mat-icon class="add-icon">add</mat-icon>
    </div>
    } @if (filteredOptions.length === 0) { @if (searchTerm) {
    <div class="no-results">
      <mat-icon>search_off</mat-icon>
      <span>No filters found</span>
    </div>
    } @else {
    <div class="no-filters">
      <mat-icon>filter_list_off</mat-icon>
      <span>All filters are already added</span>
    </div>
    } }
  </div>
</mat-menu>
